module.exports = __webpack_public_path__ + "img/1.3.ea327336.png";